/*
  Moya drawing: turns a child's drawing into a short code that fits in a link and on an order line,
  and turns that code back into a picture, a high-resolution PNG or an SVG for the laser.
  Strokes are stored as points on a 256 x 256 grid, simplified, then packed into URL-safe base64.
*/
(function () {
  function b64e(bytes) { var s = ''; for (var i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]); return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function b64d(str) { str = String(str).replace(/-/g, '+').replace(/_/g, '/'); while (str.length % 4) str += '='; var s = atob(str), a = new Uint8Array(s.length); for (var i = 0; i < s.length; i++) a[i] = s.charCodeAt(i); return a; }
  function rdp(pts, eps) {
    if (pts.length < 3) return pts;
    var a = pts[0], b = pts[pts.length - 1], dx = b[0] - a[0], dy = b[1] - a[1], len = Math.hypot(dx, dy) || 1, dmax = 0, idx = 0;
    for (var i = 1; i < pts.length - 1; i++) { var d = Math.abs(dy * pts[i][0] - dx * pts[i][1] + b[0] * a[1] - b[1] * a[0]) / len; if (d > dmax) { dmax = d; idx = i; } }
    if (dmax > eps) { var l = rdp(pts.slice(0, idx + 1), eps), r = rdp(pts.slice(idx), eps); return l.slice(0, -1).concat(r); }
    return [a, b];
  }
  function encode(strokes) {
    var out = [1];
    strokes.forEach(function (s) {
      var q = [];
      s.pts.forEach(function (p) {
        var x = Math.round(Math.max(0, Math.min(1, p[0])) * 255), y = Math.round(Math.max(0, Math.min(1, p[1])) * 255), l = q[q.length - 1];
        if (!l || l[0] !== x || l[1] !== y) q.push([x, y]);
      });
      if (!q.length) return;
      var simp = rdp(q, 0.7), n = Math.min(simp.length, 65535);
      out.push(s.w === 2 ? 2 : 1, n >> 8, n & 255);
      for (var i = 0; i < n; i++) out.push(simp[i][0], simp[i][1]);
    });
    return out.length > 1 ? b64e(out) : '';
  }
  function decode(code) {
    try {
      var a = b64d(code), i = 1, strokes = [];
      if (a[0] !== 1) return [];
      while (i + 3 <= a.length) {
        var w = a[i], n = (a[i + 1] << 8) | a[i + 2], pts = [];
        i += 3;
        for (var k = 0; k < n && i + 1 < a.length + 1; k++) { pts.push([a[i] / 255, a[i + 1] / 255]); i += 2; }
        if (pts.length) strokes.push({ w: w === 2 ? 2 : 1, pts: pts });
      }
      return strokes;
    } catch (e) { return []; }
  }
  function lineWidth(w, unit) { return unit * (w === 2 ? 0.045 : 0.02); }
  function bounds(strokes) {
    var x1 = 1, y1 = 1, x2 = 0, y2 = 0;
    strokes.forEach(function (s) { s.pts.forEach(function (p) { x1 = Math.min(x1, p[0]); y1 = Math.min(y1, p[1]); x2 = Math.max(x2, p[0]); y2 = Math.max(y2, p[1]); }); });
    var pad = 0.03;
    if (x2 < x1) return { x: 0, y: 0, w: 1, h: 1 };
    x1 -= pad; y1 -= pad; x2 += pad; y2 += pad;
    return { x: x1, y: y1, w: Math.max(0.05, x2 - x1), h: Math.max(0.05, y2 - y1) };
  }
  // Draw strokes where 1 unit of the drawing = `unit` pixels, offset by ox, oy
  function paint(ctx, strokes, ox, oy, unit, style) {
    ctx.save();
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.strokeStyle = style; ctx.fillStyle = style;
    strokes.forEach(function (s) {
      var lw = lineWidth(s.w, unit), P = s.pts.map(function (p) { return [ox + p[0] * unit, oy + p[1] * unit]; });
      ctx.lineWidth = lw;
      if (P.length === 1) { ctx.beginPath(); ctx.arc(P[0][0], P[0][1], lw / 2, 0, Math.PI * 2); ctx.fill(); return; }
      ctx.beginPath(); ctx.moveTo(P[0][0], P[0][1]);
      for (var i = 1; i < P.length - 1; i++) { ctx.quadraticCurveTo(P[i][0], P[i][1], (P[i][0] + P[i + 1][0]) / 2, (P[i][1] + P[i + 1][1]) / 2); }
      var L = P[P.length - 1]; ctx.lineTo(L[0], L[1]); ctx.stroke();
    });
    ctx.restore();
  }
  // Fit the drawing (cropped to what was drawn) into a rectangle
  function paintFit(ctx, strokes, rect, style) {
    if (!strokes.length) return;
    var b = bounds(strokes), unit = Math.min(rect.w / b.w, rect.h / b.h);
    paint(ctx, strokes, rect.x + (rect.w - b.w * unit) / 2 - b.x * unit, rect.y + (rect.h - b.h * unit) / 2 - b.y * unit, unit, style);
  }
  function toPNG(strokes, size) {
    var b = bounds(strokes), unit = size / Math.max(b.w, b.h);
    var c = document.createElement('canvas');
    c.width = Math.round(b.w * unit); c.height = Math.round(b.h * unit);
    paint(c.getContext('2d'), strokes, -b.x * unit, -b.y * unit, unit, '#000000');
    return c.toDataURL('image/png');
  }
  function toSVG(strokes, size) {
    var b = bounds(strokes), unit = size / Math.max(b.w, b.h), W = Math.round(b.w * unit), H = Math.round(b.h * unit), parts = [];
    function f(n) { return (Math.round(n * 10) / 10).toString(); }
    strokes.forEach(function (s) {
      var lw = lineWidth(s.w, unit), P = s.pts.map(function (p) { return [(p[0] - b.x) * unit, (p[1] - b.y) * unit]; });
      if (P.length === 1) { parts.push('<circle cx="' + f(P[0][0]) + '" cy="' + f(P[0][1]) + '" r="' + f(lw / 2) + '" fill="#000"/>'); return; }
      var d = 'M' + f(P[0][0]) + ' ' + f(P[0][1]);
      for (var i = 1; i < P.length - 1; i++) d += ' Q' + f(P[i][0]) + ' ' + f(P[i][1]) + ' ' + f((P[i][0] + P[i + 1][0]) / 2) + ' ' + f((P[i][1] + P[i + 1][1]) / 2);
      var L = P[P.length - 1]; d += ' L' + f(L[0]) + ' ' + f(L[1]);
      parts.push('<path d="' + d + '" fill="none" stroke="#000" stroke-width="' + f(lw) + '" stroke-linecap="round" stroke-linejoin="round"/>');
    });
    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + W + '" height="' + H + '" viewBox="0 0 ' + W + ' ' + H + '">' + parts.join('') + '</svg>';
  }
  function download(href, name) { var a = document.createElement('a'); a.href = href; a.download = name; document.body.appendChild(a); a.click(); a.remove(); }
  function silver(ctx, y, h) { var g = ctx.createLinearGradient(0, y, 0, y + h); g.addColorStop(0, '#FAFBFC'); g.addColorStop(0.55, '#BAC2CB'); g.addColorStop(1, '#8D97A2'); return g; }
  // Save a finished picture. Computers download it straight away. Phones get a preview with a
  // "Save to my phone" button that opens the share sheet (Save Image puts it in Photos),
  // because a plain download on a phone just disappears into the Files app.
  function saveCanvas(canvas, name) {
    canvas.toBlob(function (blob) {
      if (!blob) return;
      var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      if (!touch) { var u = URL.createObjectURL(blob); download(u, name); setTimeout(function () { URL.revokeObjectURL(u); }, 10000); return; }
      showSaver(blob, name);
    }, 'image/png');
  }
  function showSaver(blob, name) {
    var url = URL.createObjectURL(blob), file = null;
    try { file = new File([blob], name, { type: 'image/png' }); } catch (e) {}
    var canShare = !!(file && navigator.canShare && navigator.share && navigator.canShare({ files: [file] }));
    var btn = 'display:block;width:100%;margin-top:12px;padding:14px 16px;border-radius:999px;border:3px solid #1E2152;color:#1E2152;font:600 18px Fredoka,Nunito,Arial,sans-serif;cursor:pointer;';
    var o = document.createElement('div');
    o.setAttribute('role', 'dialog'); o.setAttribute('aria-modal', 'true'); o.setAttribute('aria-label', 'Save your picture');
    o.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:rgba(30,33,82,0.72);display:flex;align-items:center;justify-content:center;padding:16px;';
    o.innerHTML = '<div style="background:#fff;border:3px solid #1E2152;border-radius:24px;box-shadow:0 8px 0 #1E2152;max-width:420px;width:100%;max-height:100%;overflow:auto;padding:16px;text-align:center;font-family:Nunito,Arial,sans-serif;color:#1E2152;">' +
      '<img alt="Your picture" style="display:block;width:100%;height:auto;max-height:55vh;object-fit:contain;border-radius:12px;-webkit-touch-callout:default;">' +
      '<button type="button" data-save style="' + btn + 'background:#FFB627;box-shadow:0 4px 0 #1E2152;">' + (canShare ? 'Save to my phone' : 'Download') + '</button>' +
      '<p style="margin:12px 0 0;font-weight:700;font-size:14px;line-height:1.4;">Or press and hold the picture to save it.</p>' +
      '<button type="button" data-close style="' + btn + 'background:#fff;font-size:16px;padding:10px 16px;">Close</button></div>';
    o.querySelector('img').src = url;
    function close() { document.removeEventListener('keydown', esc); o.remove(); setTimeout(function () { URL.revokeObjectURL(url); }, 1000); }
    function esc(e) { if (e.key === 'Escape') close(); }
    o.querySelector('[data-save]').addEventListener('click', function () {
      if (canShare) navigator.share({ files: [file], title: 'My Moya' }).catch(function () {});
      else download(url, name);
    });
    o.querySelector('[data-close]').addEventListener('click', close);
    o.addEventListener('click', function (e) { if (e.target === o) close(); });
    document.addEventListener('keydown', esc);
    document.body.appendChild(o);
    o.querySelector('[data-save]').focus();
  }
  window.MoyaDrawing = { encode: encode, decode: decode, paint: paint, paintFit: paintFit, bounds: bounds, toPNG: toPNG, toSVG: toSVG, download: download, silver: silver, saveCanvas: saveCanvas };
})();
